"use client"
import CounterCards from "@/components/cards-components/CounterCard"
import { COLORS } from "@/theme/localTheme"
import {
  Box,
  Button,
  Chip,
  ChipProps,
  FormControl,
  IconButton,
  Link,
  MenuItem,
  Select,
  Typography,
  SxProps,
  Stack,
  CircularProgress,
  FormControlLabel,
  Checkbox,
} from "@mui/material"
import ManSitting from "../../utils/assets/images/CounterCards/ManSitting.svg"
import BooksSpread from "../../utils/assets/images/CounterCards/BooksSpread.svg"
import Calculator from "../../utils/assets/images/CounterCards/Calculator.svg"
import adminAppHome from "../../utils/assets/images/adminAppHome.png"
import Image from "next/image"
import { GridCellParams, GridRenderCellParams, GridRowClassNameParams } from "@mui/x-data-grid"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { useInfiniteQuery, useMutation, useQuery } from "react-query"
import { apiClient } from "@/apiClient/apiService"
import ApiEndpoints, { API_END_POINT, ROUTES } from "@/apiClient/apiEndpoints"
import { ArrivalDepartureTicket, ItemsEntity } from "../../../interface/ArrivalDepartureTicket"
import { PurchaseInternalEmployees } from "../../../interface/PurchaseInternalEmployees"
import { useCallback, useMemo, useRef, useState } from "react"
import CustomTooltip from "@/components/layout-components/CustomToolTip"
import ProtectedAuth from "../ProtectedAuth"
import { toast } from "react-toastify"
import ModalPopup from "@/components/ModalComponents/ModalPopup"
import dayjs from "dayjs"
import InfiniteTable from "@/components/TableComponent/InfiniteTable"
import { FilterSortExtractor, calculateToFromFilter } from "@/components/TableComponent/InfiniteTableExt"
import CustomAvatar from "@/components/field-components/CustomAvatar"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { TReadTicket } from "../../../interface/ReadTicket"
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"
import NotesModule from "@/views/NotesModule/NotesModule"
import useInfiniteTable from "@/components/TableComponent/useInfiniteTable"
import FlagIcon from "../../utils/assets/images/FlagIcon.svg"
import CounterCardFilter from "@/components/cards-components/CounterCardFilter"
import AppStore from "@/store/AppStore"
import { ModuleName, TAPIPayload } from "@/store/AppStore.types"
import { observer } from "mobx-react"
import { toJS } from "mobx"
import OwnerStaysIcon from "../../utils/assets/images/OwnerStays.svg"
import FilterIcon from "../../utils/assets/images/FilterIcon.svg"
import FilterDDIcon from "../../utils/assets/images/FilterDDIcon.svg"
import FilterPopover from "@/components/AdvancedFilter/FilterPopover"
import { ExtendedGridColDef } from "../../../interface/InfiniteTable"
import useProperties from "@/hooks/useProperties"
import useUserDetails from "@/hooks/useUserDetails"
import useRoles from "@/hooks/useRoles"
import { UserDetails } from "../../../interface/UserDetails"
import Switch from "@/components/Switch/Switch"
import OwnersActionModal from "@/views/tabs/owners/OwnersActionModal"
import { Check, Close, Download } from "@mui/icons-material"
import { AdminUserIcon, GroupUserIcon, OwnerIcon } from "@/utils/assets/svgs"
import { downloadFile } from "@/utils/CommonFunctions"
import Loader from "@/components/Loader/Loader"

interface TicketAssign {
  assigned_id: number
  ticket_id: number
}

interface AssignTicketData {
  ticket_id: number
  ticket_assign_form: {
    assigned_to: number | string
    status: string | undefined
    event_type: string | undefined
    scheduled_date: string | undefined
  }
}

interface filterInt {
  [key: string]: string | number
}
interface sortInt {
  field_name: string | number
  orderBy: "asc" | "desc"
}

interface INotReqFlag {
  open: boolean
  title: string
  desc: string
  details?: {
    rowId: number
    ticketId: number
    requestType: "arrival" | "departure"
    checked: boolean
  }
  ownerId: string
  submit?: {
    label: string
  }
}

interface updatePriority {
  id: number
  priorityNumber: string
}

interface formInput {
  priorityUpdate: updatePriority
  addNote: addNote
}

interface addNote {
  notes: string
  subject: string
  images: [] | any
  propertydetails_id: number
  ticket_id: number
}

function arrivalAndDepartureReviewStatus(params: GridRenderCellParams): ChipProps {
  const isReviewed = params?.row?.is_reviewed
  const label = isReviewed ? "Yes" : "No"
  const icon = isReviewed ? <Check style={{ color: "white" }} /> : <Close style={{ color: "white" }} />

  if (isReviewed === true) {
    return {
      label: label,
      style: {
        backgroundColor: COLORS.brandBlue,
        border: "none",
      },
      icon,
    }
  } else {
    return {
      label: label,
      style: {
        backgroundColor: COLORS.red,
        border: "none",
      },
      icon,
    }
  }
}

const ArrivalDepartureHome = () => {
  const [openNotesModal, setOpenNotesModal] = useState<boolean>(false)
  const [modalBookingNotesModal, setModalBookingNotesModal] = useState<ItemsEntity | null>(null)
  const filterAnchorDebugref = useRef(null)
  const [filterPopper, setFilterPopper] = useState<boolean>(false)
  const [notRequiredModal, setNotRequiredModal] = useState<INotReqFlag>({ open: false, title: "", desc: "", ownerId: "" })
  const [notesList, setNotesList] = useState<Array<any>>([])
  const [totalNumberOfTickets, setTotalNumberOfTickets] = useState<number>(0)

  const isCancelledRef = useRef<boolean>(false)
  const isNotRequiredRef = useRef<boolean>(false)

  const { filterRef, sortRef, isNextPage, infiniteTableKey, tableAPIRef, resetQuery } = useInfiniteTable(ModuleName.AND)
  const { data: userDetailsData } = useUserDetails()
  const { isEmployee, isAdmin, isManager } = useRoles(userDetailsData?.data as UserDetails)

  const [selectedOptions, setSelectedOptions] = useState<{
    ticket_id: string
    type: string
    pdf_type?: "guest" | "admin" | "owner"
    services_type?: string
  } | null>(null)

  const { data: properties, isFetched: isFetchedProperty } = useProperties({ enabled: isAdmin || isManager })

  const propertyList = useMemo(() => {
    if (!properties?.data?.data) {
      return []
    }

    return properties.data.data
      .sort((a, b) => String(a.property_code).localeCompare(String(b.property_code)))
      .map((item) => ({
        alias: item?.property_code,
        value: item?.property_code,
        label: `${item?.property_code} (${item?.property_name})`,
      }))
  }, [properties])

  const { data: andCounter, refetch: refetchAnDCounter } = useQuery<any>({
    queryKey: ["andCount"],
    queryFn: async () => {
      const prevFilters = calculateToFromFilter(AppStore.counterCardFilter[infiniteTableKey])
      return await apiClient.post(ApiEndpoints.POST[ROUTES.getaArrivalDepartureCountv2], { ...prevFilters })
    },
  })

  const { data: internalEmployeesData, isFetched: isFetchedEmployees } = useQuery<{
    data: PurchaseInternalEmployees
  }>({
    queryKey: ["internalEmployees"],
    queryFn: async () => {
      return await apiClient.get(ApiEndpoints.GET[ROUTES.getPurchaseInternalEmployees])
    },
  })

  const internalEmpList = useMemo(() => {
    if (!internalEmployeesData?.data?.data) {
      return []
    }

    const tempEmp = internalEmployeesData?.data?.data.map((item) => ({
      alias: item?.Full_Name,
      value: item?.id,
      label: item?.Full_Name,
    }))
    return [{ label: "Unassinged", value: "", alias: "Unassinged" }, ...tempEmp]
  }, [internalEmployeesData])

  const postArrivalDepartureTicket = async (pageParam: number) => {
    let data = FilterSortExtractor({
      page: pageParam,
      tableRef: tableAPIRef.current.rootElementRef,
      filterRef,
      sortRef,
      filterFlag: true,
      perPage: "calculate",
    })

    const res: ArrivalDepartureTicket = await apiClient.post(`${ApiEndpoints.POST[ROUTES.getPostArrivalDepartureTicketv2]}`, {
      ...data,
      hide_inactive: AppStore.isHideInactiveTickets[infiniteTableKey].isTrue,
    })
    isNextPage.current = res.data?.nextPage !== null

    return {
      data: res,
    }
  }

  const { data: arrDeptTicketData, ...arrDeptRest } = useInfiniteQuery<{
    data: ArrivalDepartureTicket
  }>({
    queryKey: [infiniteTableKey],
    queryFn: ({ pageParam = 1 }) => postArrivalDepartureTicket(pageParam),
    getNextPageParam: (lastPage, pages) => lastPage?.data?.data?.nextPage || 1,
    onSuccess: (resp) => {
      setTotalNumberOfTickets(resp.pages[0]?.data?.data.itemsTotal || 0)
    },
  })

  const readTicket = useMutation({
    mutationFn: (data: TReadTicket) => {
      return apiClient.post(`${API_END_POINT.POST[ROUTES.readTicket]}/${data.ticketId}`, { read: data.read, rid: data.rid })
    },
    onSuccess: (data: any) => {
      // arrDeptTicketData.refetch()
      if (tableAPIRef.current) {
        const rowId = data.data.rid
        const prev = tableAPIRef.current.getRow(rowId)
        prev.read = true // Javascript g0d //
        refetchAnDCounter()
      }
    },
  })

  const assignArrivalDepartureForm = useMutation({
    mutationFn: (data: TicketAssign) => {
      return apiClient.post(`${API_END_POINT.POST[ROUTES.postArrivalDepartureTicketAssign]}`, data)
    },
    onSuccess: () => {
      toast.success("Ticket Assigned", {
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      arrDeptRest.refetch()
    },
  })

  const arrivalDepartureFullForm = useMutation({
    mutationFn: (data: AssignTicketData) => {
      return apiClient.post(`${API_END_POINT.POST[ROUTES.postArrivalDepartureTicketFormAssign]}`, data)
    },
    onSuccess: () => {
      toast.success("Due Date Updated", {
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      arrDeptRest.refetch()
    },
  })

  const handleAssignedToChange = (event: React.ChangeEvent<{ value: unknown }>, params: any) => {
    const assignedId = event.target.value as number
    const ticketId = params.value.ticket_id

    toast.success("Ticket Assigning...", {
      position: "top-right",
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      autoClose: 250,
    })

    assignArrivalDepartureForm.mutate({
      assigned_id: assignedId,
      ticket_id: ticketId,
    })
  }
  const handleOpenNotesModal = (params: any) => {
    setOpenNotesModal(true)
    setNotesList(params.row.notes_list)
    if (params && params.row) {
      setModalBookingNotesModal(params.row)
    }
  }

  function getChipProps(params: GridRenderCellParams): ChipProps {
    const isCancelled = params.field === "current_status" && params?.row?.reservation?.status === "cancelled"
    var isRead = params.row.read
    const isNotRequired = params.field === "current_status" && params.row.not_required_flag

    if (isCancelled) {
      return {
        label: "Cancelled",
        style: {
          backgroundColor: "#F97300",
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "100px",
        },
      }
    } else if (isNotRequired) {
      return {
        label: "Not Required",
        style: {
          backgroundColor: "#007CD6",
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else if (params.value === "Open") {
      return {
        label: isRead ? "Open" : "New",
        style: {
          backgroundColor: isRead ? COLORS.adminAppBgColorV2 : COLORS.newChipRed,
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else if (params.value === "Scheduled") {
      return {
        label: params.value,
        style: {
          backgroundColor: COLORS.lightGreen,
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else if (params.value === "In-progress") {
      return {
        label: params.value,
        style: {
          backgroundColor: COLORS.blue,
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else if (params.value === "arrival") {
      return {
        label: "Arrival",
        style: {
          backgroundColor: "#6d0093",
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else if (params.value === "departure") {
      return {
        label: "Departure",
        style: {
          backgroundColor: COLORS.darkGreen,
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else if (params.value === "Completed") {
      return {
        label: params.value,
        style: {
          backgroundColor: "#949704",
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    } else {
      return {
        label: params.value,
        style: {
          backgroundColor: COLORS.darkGreen,
          color: COLORS.adminAppTextSecondary,
          border: "none",
          width: "110px",
        },
      }
    }
  }

  const sortIdMap: filterInt = {
    scheduled_date: "scheduled_date",
    services_type: "services_type",
    current_status: "current_status",
    reservation: "reservation_id",
    property_details: "property_code",
    booking_date: "arrival_date",
    completed_date: "completed_date",
    reviewed: "is_review",
    actions: "priority",
  }

  const isNotRequiredColumn: ExtendedGridColDef = {
    field: "not_required_flag",
    filterKey: isAdmin || isManager ? "not_required_flag_filter" : undefined,
    headerName: "Not Required",
    filterable: false,
    sortable: false,
    type: "singleSelect",
    valueOptions: [
      { value: true, label: "Yes", alias: "Yes" },
      { value: false, label: "No", alias: "No" },
    ],
    renderCell: (params) => {
      const isNotRequired = params.value
      const isCancelled = params?.row?.reservation?.status === "cancelled"
      return (
        <>
          <CustomTooltip title={isCancelled ? "" : `Mark as ${!isNotRequired ? "Not" : ""} Required`}>
            <Box display="flex" justifyContent="center" width="100%">
              <Switch
                checked={params.value}
                disabled={isCancelled}
                onChange={(event, checked: boolean) => {
                  onChangeNotRequiredModal(checked, params.row)
                }}
              />
            </Box>
          </CustomTooltip>
        </>
      )
    },
  }

  const { mutate: downloadMutate, isLoading: downloadLoading } = useMutation({
    mutationFn: (data: { ticket_id: string; pdf_type: string; type: string }) => {
      return apiClient.get(
        `${API_END_POINT.GET[ROUTES.getPdfForArrivalDepartureForm]}?ticket_id=${data.ticket_id}&type=${data.type.toLowerCase()}&page_no=1&pdf_type=${data.pdf_type}`,
      )
    },
    onSuccess: (response: any) => {
      if (response.data?.length) {
        downloadFile(response.data as string)
        setSelectedOptions(null)
        toast.success("PDF report downloaded successfully!")
      }
    },
  })

  const downloadPdfReport = useCallback(
    ({
      ticket_id,
      type,
      pdf_type,
      serviceType,
    }: {
      ticket_id: string
      type: string
      pdf_type?: "admin" | "guest" | "admin"
      serviceType: "arrival" | "departure"
    }) => {
      if (serviceType === "arrival" && pdf_type?.length) {
        setSelectedOptions({ ticket_id, pdf_type, type })
        downloadMutate({ ticket_id, pdf_type, type })
        return
      } else {
        setSelectedOptions({ ticket_id, pdf_type, type, services_type: serviceType })
      }
    },
    [downloadMutate],
  )

  const columns: Array<ExtendedGridColDef> = [
    {
      field: "reservation",
      filterKey: "hostaway_reservation_id",
      sortKey: "reservation_id",
      headerName: "Reservation ID",
      sortable: true,
      filterable: false,
      renderCell: (params) => {
        const isOwner = params?.row?.reservation?.status === "ownerStay"
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center", width: "max-content", position: "relative" }}>
            {isOwner && (
              <CustomTooltip title={"Owner Stay"}>
                <Image
                  src={OwnerStaysIcon}
                  alt={"Owner"}
                  width={20}
                  height={20}
                  style={{ position: "absolute", left: "-30px", top: "50%", transform: "translateY(-50%)" }}
                />
              </CustomTooltip>
            )}
            <CustomTooltip
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <b>Guest Name: </b>
                    {params?.value?.guestName}
                  </div>
                  <div>
                    <b>Email: </b>
                    {params?.value?.guestEmail}
                  </div>
                  <div>
                    <b>Phone:</b> {params?.value?.phone}
                  </div>
                </div>
              }
            >
              <div>{params.value?.hostawayReservationId}</div>
            </CustomTooltip>
          </Box>
        )
      },
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "property_details",
      filterKey: "property_code",
      sortKey: "property_code",
      headerName: "Property Code",
      filterable: false,
      sortable: true,
      type: "singleSelect",
      // @ts-ignore
      valueOptions: propertyList,
      renderCell: (params) => {
        const propertyName = params?.value?.property_name || ""
        const truncatedName = propertyName.length > 10 ? `${propertyName.substring(0, 16)}...` : propertyName

        return (
          <Box display={"flex"} flexDirection={"column"}>
            <CustomTooltip
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <b>Property Name:</b> {propertyName}
                  </div>
                  <div>
                    <b>Address:</b> {params?.value?.address}
                  </div>
                </div>
              }
            >
              <div>{params?.value?.property_code}</div>
            </CustomTooltip>
          </Box>
        )
      },
      headerAlign: "center",
      align: "center",
      minWidth: 250,
      flex: 1,
    },
    {
      field: `services_type`,
      filterKey: "services_type",
      sortKey: "services_type",
      headerName: "Event Type",
      // flex: 1,
      sortable: true,
      filterable: false,
      type: "singleSelect",
      valueOptions: [
        { value: "arrival", label: "Arrival", alias: "Arrival" },
        { value: "departure", label: "Departure", alias: "Departure" },
      ],
      renderCell: (params) => {
        return <Chip variant="outlined" size="small" {...getChipProps(params)} />
      },
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "ticket_status",
      filterKey: isAdmin || isManager ? "assigned_to_id" : "assigned_to",
      sortKey: "assigned_to",
      headerName: "Assigned To",
      headerAlign: "center",
      type: isAdmin || isManager ? "singleSelect" : "string",
      // @ts-ignore
      valueOptions: isAdmin || isManager ? internalEmpList : undefined,
      filterable: false,
      align: "center",
      sortable: true,
      renderCell: (params) => {
        const isCancelled = params?.row?.reservation?.status === "cancelled"
        const isNotRequired = params?.row?.not_required_flag
        return (
          <>
            {params?.value?.assigned_to?.Full_Name ? (
              <CustomTooltip title={params?.value?.assigned_to?.Full_Name}>
                <CustomAvatar name={params?.value?.assigned_to?.Full_Name} />
              </CustomTooltip>
            ) : (
              <CustomTooltip title={"Unassigned"}>
                <CustomAvatar name={"UN"} unknown={true} />
              </CustomTooltip>
            )}

            {!isCancelled && !isNotRequired && params.row.current_status !== "Completed" ? (
              <FormControl>
                <Select
                  defaultValue="Unassigned"
                  onChange={(event: any) => handleAssignedToChange(event, params)}
                  sx={{
                    ".MuiTypography-root": {
                      display: "none",
                    },
                    "& fieldset": {
                      border: "none",
                    },
                  }}
                >
                  {internalEmpList.map(({ label, value }) => {
                    return (
                      <MenuItem key={value} value={value}>
                        <Typography>{label}</Typography>
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            ) : (
              <Box width={"46px"}></Box>
            )}
          </>
        )
      },
      minWidth: 250,
      flex: 1,
    },
    {
      field: "current_status",
      filterKey: "current_status",
      sortKey: "current_status",
      headerName: "Status",
      sortable: true,
      filterable: false,
      type: "singleSelect",
      valueOptions: [
        { value: "Open", label: "New / Open", alias: "New / Open" },
        { value: "In-progress", label: "In-Progress" },
        { value: "Scheduled", label: "Scheduled" },
        { value: "Completed", label: "Completed" },
      ],
      renderCell: (params) => {
        return <Chip variant="outlined" size="small" {...getChipProps(params)} />
      },
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: `booking_date`,
      headerName: "Arr / Dep Date",
      description: "Arrival / Departure Date",
      type: "date",
      sortable: true,
      filterable: false,
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => {
        const isArrival = params.row.services_type === "arrival"
        const { arrivalDate, departureDate } = params.row.reservation
        const broadText: SxProps = { fontSize: "16px", fontWeight: 500 }
        const smallText: SxProps = { fontSize: "12px", fontWeight: 400, color: "rgba(255, 255, 255, 0.70)" }
        const arrDayJs = dayjs(arrivalDate, "YYYY-MM-DD").format("DD-MM-YYYY")
        const depDayJs = dayjs(departureDate, "YYYY-MM-DD").format("DD-MM-YYYY")
        return (
          <CustomTooltip
            title={
              <div>
                <div>
                  <b>Arrival Date :</b> {arrDayJs}
                </div>
                <div>
                  <b>Departure Date :</b> {depDayJs}
                </div>
              </div>
            }
          >
            <Box sx={{ textAlign: "center" }}>
              <Box sx={isArrival ? broadText : smallText}>{arrDayJs}</Box>
              <Box sx={isArrival ? smallText : broadText}>{depDayJs}</Box>
            </Box>
          </CustomTooltip>
        )
      },
      headerAlign: "center",
      align: "center",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "scheduled_date",
      filterKey: "scheduled_date_filter",
      outputFormat: "localOffsetTS",
      sortKey: "scheduled_date",
      headerName: "Due Date",
      // flex: 1,
      type: "date",
      sortable: true,
      filterable: false,
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => {
        const timestamp = params?.value

        // Create a Date object from the timestamp
        const date = new Date(timestamp)

        // Extract day, month, and year components
        const day = date.getDate()
        const month = date.getMonth() + 1 // Months are zero-based, so add 1
        const year = date.getFullYear()

        // Format the date components as strings with leading zeros if necessary
        const formattedDay = day < 10 ? `0${day}` : `${day}`
        const formattedMonth = month < 10 ? `0${month}` : `${month}`
        const formattedYear = year < 10 ? `0${year}` : `${year}`

        // Create the formatted date string in "dd/mm/yy" format
        const formattedDate = `${formattedDay}-${formattedMonth}-${formattedYear}`

        const isCancelled = params?.row?.reservation?.status === "cancelled"
        const isNotRequired = params?.row?.not_required_flag

        return (
          <>
            <Box display="flex" flexDirection="row" justifyContent="center" textAlign="center">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={dayjs(formattedDate, "DD-MM-YYYY")}
                  onChange={(date) => {
                    if (isCancelled && isNotRequired) return false
                    const json = {
                      ticket_id: params.row.ticket_status.ticket_id,
                      ticket_assign_form: {
                        assigned_to: params.row.ticket_status.assigned_id,
                        status: params.row.ticket_status.t_status,
                        event_type: params.row.services_type,
                        scheduled_date: date?.format("YYYY-MM-DD"),
                      },
                    }
                    arrivalDepartureFullForm.mutate(json)
                  }}
                  format="DD-MM-YYYY"
                  sx={{
                    width: "100px",
                    "& fieldset": {
                      border: "none",
                    },
                    "& input": {
                      padding: 0,
                      margin: 0,
                      fontWeight: 400,
                      lineHeight: 1.5,
                      letterSpacing: "0.00938em",
                      fontSize: "0.8rem",
                      color: "#FFFFFFB2",
                      "&.Mui-disabled": {
                        WebkitTextFillColor: "#FFFFFFB2",
                      },
                    },
                    "& .MuiInputAdornment-positionEnd": {
                      marginLeft: 0,
                      button: {
                        padding: 0,
                      },
                    },
                  }}
                  disabled={isCancelled || isNotRequired}
                  disableOpenPicker={isCancelled || isNotRequired}
                />
              </LocalizationProvider>
            </Box>
          </>
        )
      },
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "completed_date",
      filterKey: "completed_date_filter",
      sortKey: "completed_date",
      headerName: "Completed Date",
      type: "date",
      sortable: true,
      filterable: false,
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => {
        const isCompleted = params.row?.current_status === "Completed"
        const completedAt = params?.row?.completed_timestamp ?? params?.row?.ticket_status?.completed_date
        const arrDayJs = isCompleted && completedAt ? dayjs(completedAt).format("DD-MM-YYYY") : ""

        return <Box sx={{ textAlign: "center" }}>{arrDayJs}</Box>
      },
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "owner_stays",
      filterKey: "is_owner_stay",
      headerName: "Owner Stays",
      filterable: false,
      sortable: false,
      type: "singleSelect",
      valueOptions: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
      renderCell: (params) => {
        const isOwner = params?.row?.reservation?.status === "ownerStay"
        return (
          <Box textAlign={"center"} width="100%">
            {isOwner ? "Yes" : "No"}
          </Box>
        )
      },
    },
    {
      field: "res_status",
      filterKey: "res_status_filter",
      headerName: "Reservation Status",
      filterable: false,
      sortable: false,
      type: "singleSelect",
      valueOptions: [{ value: "cancelled", label: "Cancelled", alias: "Cancelled" }],
      renderCell: (params) => {
        return (
          <Box textAlign={"center"} width="100%" textTransform={"capitalize"}>
            {params?.row?.reservation?.status}
          </Box>
        )
      },
    },
    {
      field: "guest_issue",
      filterKey: "has_guest_issue",
      headerName: "Guest Issue",
      description: "Guest Completed Issue",
      filterable: false,
      sortable: false,
      type: "singleSelect",
      valueOptions: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
      renderCell: (params) => {
        const isCompleted = params.row?.current_status === "Completed"
        const guestCompletedIssue = isCompleted && params?.row?.guest_depart_issue === "yes"
        return (
          <Box textAlign={"center"} width="100%">
            {guestCompletedIssue ? "Yes" : isCompleted ? "No" : ""}
          </Box>
        )
      },
    },
    {
      field: "arrival_date",
      filterKey: "arrival_date_filter",
      outputFormat: "localOffsetTS",
      sortKey: "arrival_date",
      headerName: "Arrival Date",
      type: "date",
      sortable: false,
      filterable: false,
      headerAlign: "center",
      minWidth: 150,
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => {
        const { arrivalDate } = params.row.reservation
        const arrDayJs = dayjs(arrivalDate, "YYYY-MM-DD").format("DD-MM-YYYY")
        return <Box sx={{ textAlign: "center", width: "100%" }}>{arrDayJs}</Box>
      },
    },
    {
      field: "departure_date",
      filterKey: "departure_date_filter",
      outputFormat: "localOffsetTS",
      sortKey: "departure_date",
      headerName: "Departure Date",
      type: "date",
      sortable: false,
      filterable: false,
      headerAlign: "center",
      minWidth: 150,
      valueGetter: (params) => new Date(params.value),
      renderCell: (params) => {
        const { departureDate } = params.row.reservation
        const depDayJs = dayjs(departureDate, "YYYY-MM-DD").format("DD-MM-YYYY")
        return <Box sx={{ textAlign: "center", width: "100%" }}>{depDayJs}</Box>
      },
    },
    {
      field: "reviewed",
      filterKey: "is_reviewed",
      sortKey: "reviewed",
      headerName: "Reviewed",
      type: "singleSelect",
      filterable: false,
      sortable: true,
      valueOptions: [
        { value: "true", label: "Yes", alias: "Yes" },
        { value: "false", label: "No", alias: "No" },
      ],
      renderCell: (params) => {
        return <Chip variant="outlined" size="small" sx={{ color: "white" }} {...arrivalAndDepartureReviewStatus(params)} />
      },
      align: "center",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      filterable: false,
      sortable: true,
      sortKey: "priority_type",
      renderCell: (params) => {
        const notesAvailable = params?.row?.notes?.hostNote || params?.row?.notes?.guestNote
        const guestCompletedIssue = params.row?.current_status === "Completed" && params?.row?.guest_depart_issue?.toLowerCase() === "yes"
        const isCancelled = params?.row?.reservation?.status === "cancelled"
        const isNotRequired = params?.row?.not_required_flag
        const isReviewed = params.row.is_reviewed
        const priority = params.row.priority || "NA"
        return (
          <Box sx={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", columnGap: "15px" }}>
            <CustomTooltip
              title={guestCompletedIssue ?
                <div style={{ textAlign: "center", fontSize: "12px" }}>
                  {params?.row?.departure_issue || "Guest Departure Completed with an Issue"}
                </div>
                : null}
            >
              <Box sx={{ padding: "8px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Image src={FlagIcon} alt="Flag Icon" style={{ visibility: guestCompletedIssue ? "inherit" : "hidden" }} width={24} height={24} />
              </Box>
            </CustomTooltip>
            {priority ? (
              <CustomTooltip title={priority === "ND" ? "Next Day" : priority === "BB" ? "Back to Back" : ""}>
                <CustomAvatar
                  name={priority}
                  width={24}
                  height={24}
                  fontSize={"12px"}
                  color={priority === "NA" || priority === "NR" ? "transparent" : "white"}
                  bgColor={priority === "ND" ? "#e57a2d" : priority === "BB" ? "#0e74ec" : "transparent"}
                />
              </CustomTooltip>
            ) : null}
            <IconButton
              key={"edit-button"}
              onClick={() => {
                handleOpenNotesModal(params)
                isCancelledRef.current = isCancelled
                isNotRequiredRef.current = isNotRequired
              }}
              sx={{
                padding: 0,
              }}
            >
              <CustomTooltip title="View Notes">
                {params?.row?.notes_list?.length > 0 ? (
                  <>
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <InsertDriveFileIcon
                        style={{
                          color: COLORS?.adminAppOutlineColor,
                          width: 30,
                          height: 30,
                        }}
                      />
                      <Typography
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "#fff",
                          fontSize: params?.row?.notes_list?.length > 99 ? "0.7rem" : "0.9rem",
                        }}
                      >
                        {params?.row?.notes_list?.length}
                      </Typography>
                    </div>
                  </>
                ) : (
                  <InsertDriveFileIcon style={{ color: notesAvailable ? COLORS?.adminAppOutlineColor : COLORS?.adminAppTextPrimary }} />
                )}
              </CustomTooltip>
            </IconButton>
            {!isCancelled && !isNotRequired ? (
              <CustomTooltip title="View Ticket">
                <IconButton key={"eye-button"} sx={{ padding: 0 }}>
                  <Link href={`/arrival-departure/arrival-departure-inner?id=${params.row.id}`} sx={{ height: "24px" }}>
                    <VisibilityIcon />
                  </Link>
                </IconButton>
              </CustomTooltip>
            ) : (
              <Box sx={{ width: "40px", height: "40px" }}></Box>
            )}

            <CustomTooltip title="Download Ticket">
              <IconButton
                key="download-button"
                disabled={isNotRequired}
                style={{ visibility: isReviewed ? "inherit" : "hidden" }}
                onClick={() => {
                  downloadPdfReport({
                    ticket_id: (params.row?.id || 0).toString(),
                    type: params.row.current_status,
                    pdf_type: params.row?.services_type === "arrival" ? "admin" : undefined,
                    serviceType: params.row?.services_type === "arrival" ? "arrival" : "departure",
                  })
                }}
              >
                {downloadLoading && (params.row?.id || 0).toString() === selectedOptions?.ticket_id ? <CircularProgress size={20} /> : <Download />}
              </IconButton>
            </CustomTooltip>
          </Box>
        )
      },
      headerAlign: "center",
      align: "center",
      width: 200,
    },
    {
      field: "priority",
      filterKey: "priority_type_filter",
      headerName: "Priority",
      sortable: false,
      filterable: false,
      type: "singleSelect",
      valueOptions: [
        { value: "BB", label: "Back to Back" },
        { value: "NA", label: "Not Applicable" },
      ],
      renderCell: (params) => {
        const priority = params.row?.priority_overridden ? params.row.priority_type : params.row.priority
        return (
          <Box textAlign={"center"} width="100%">
            {priority}
          </Box>
        )
      },
    },
  ]

  if (isAdmin || isManager) {
    columns.push(isNotRequiredColumn)
  }

  const onClickCounterCard = (key: string, value?: Array<string>) => {
    const prevFilters = calculateToFromFilter(AppStore.counterCardFilter[infiniteTableKey])
    let tempFilter: filterInt = {
      ...filterRef.current,
      [key]: value,
      ...prevFilters,
    }
    let tempValRef: any = filterRef.current
    tempValRef = tempValRef?.[key] || []
    if (filterRef.current.hasOwnProperty(key) && tempValRef.join("") === value?.join("")) {
      delete tempFilter[key]
    }
    filterRef.current = { ...tempFilter }
    resetQuery()
  }

  const onChangeRangeFilter = (filterData: TAPIPayload) => {
    const prevFilters = { ...filterRef.current }
    filterRef.current = { ...prevFilters, ...filterData }
    resetQuery()
    refetchAnDCounter()
  }

  const onChangeAdvFilter = (filterData: any) => {
    const prevFilters = calculateToFromFilter(AppStore.counterCardFilter[infiniteTableKey])
    filterRef.current = { ...prevFilters, ...filterData }
    resetQuery()
    refetchAnDCounter()
    setFilterPopper(false)
  }

  const onClickOpenFilters = (event: React.MouseEvent<HTMLElement>) => {
    setFilterPopper(true)
  }

  const onClickCloseFilters = (event: React.MouseEvent<HTMLElement>, reason: "backdropClick" | "escapeKeyDown" | "manual") => {
    setFilterPopper(false)
  }

  const onChangeNotRequiredModal = (checked: boolean, row: any) => {
    setNotRequiredModal({
      open: true,
      title: `Confirm mark as '${checked ? "Not " : ""}Required'?`,
      desc: `Are you sure, you ${checked ? "do not " : ""}want to proceed with the ${row.services_type} form for this reservation?`,
      details: {
        rowId: row.id,
        requestType: row.services_type,
        ticketId: row.id,
        checked,
      },
      ownerId: row.id,
      submit: {
        label: `${checked ? "Not " : ""}Required`,
      },
    })
  }

  const onCancelNotRequiredModal = () => {
    setNotRequiredModal({
      open: false,
      title: "",
      desc: "",
      ownerId: "",
    })
  }

  const postNotRequiredMutation = useMutation({
    mutationFn: (data: any) => {
      return apiClient.post(`${API_END_POINT.POST[ROUTES.updateNotRequired]}`, { ...data })
    },
  })

  const onSubmitNotRequiredModal = () => {
    const { details } = notRequiredModal
    if (details) {
      const { rowId, requestType, ticketId, checked } = details
      const prev = tableAPIRef.current.getRow(rowId)
      postNotRequiredMutation.mutate(
        {
          ticket_id: ticketId,
          request_type: requestType,
          flag_value: checked,
        },
        {
          onSuccess: () => {
            prev.not_required_flag = checked // Javascript g0d //
          },
        },
      )
    }

    setNotRequiredModal({
      open: false,
      title: "",
      desc: "",
      ownerId: "",
    })
  }

  const getCellClassName = (params: GridCellParams<any, any, number>) => {
    if (params.field !== "current_status" && params.field !== "actions") return params.row?.not_required_flag ? "ImNotRequiredCellClassMeh" : ""
    else return ""
  }

  const getRowClassName = (params: GridRowClassNameParams<any>) => {
    return params.row?.not_required_flag ? "ImNotRequiredRowClassMeh" : ""
  }

  const addNoteMutate = useMutation({
    mutationFn: (data: addNote) => {
      return apiClient.post(API_END_POINT.POST[ROUTES.addNote], data)
    },
    onSuccess: (data: any) => {
      toast.success("Note Added successfully", {
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      const rowId = data?.data?.note?.ticket_id
      if (rowId) {
        const prev = tableAPIRef.current.getRow(rowId)
        prev.notes_list.unshift(data.data.note) // Javascript g0d //
      }
    },
    onError: () => {
      toast.info("Please add note", {
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    },
  })

  const onAddNote = (data: formInput) => {
    if (modalBookingNotesModal) {
      addNoteMutate.mutate({
        notes: data.addNote.notes,
        subject: data.addNote.notes,
        images: data.addNote.images,
        propertydetails_id: modalBookingNotesModal?.propertydetails_id,
        ticket_id: modalBookingNotesModal?.ticket_status.ticket_id,
      })
    }
  }

  const downloadPdfBtnHandler = useCallback(() => {
    if (selectedOptions?.ticket_id && selectedOptions.pdf_type) {
      downloadMutate({ ticket_id: selectedOptions.ticket_id, type: selectedOptions.type, pdf_type: selectedOptions.pdf_type })
    }
  }, [downloadMutate, selectedOptions])

  const onChangeInactiveTickets = useCallback((value: boolean) => {
    AppStore.setIsHideInactiveTickets(infiniteTableKey, value)
    resetQuery()
    refetchAnDCounter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Box
        sx={{
          marginLeft: "2.5rem",
          marginRight: "2.5rem",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          marginBottom: "50px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            mb: "25px",
          }}
        >
          <Image
            src={adminAppHome.src}
            alt="adminHomeIcon"
            width={21.45}
            height={24}
            style={{
              filter: "invert(50%) brightness(100)",
            }}
          />
          <Typography sx={{ fontSize: "1.5rem", fontWeight: "600" }}>Arrival & Departure</Typography>
        </Box>
        <Box
          sx={{
            display: "grid",
            gap: "24px",
            gridTemplateColumns: "repeat(3, 1fr)",
            position: "relative",
          }}
        >
          <CounterCardFilter moduleName={ModuleName.AND} onChangeRangeFilter={onChangeRangeFilter} />
          <>
            <CounterCards
              bgImage={ManSitting.src}
              title={"Arrival Forms"}
              requestCount={andCounter?.data?.arrival_forms ?? 0}
              // @ts-ignore
              selected={filterRef.current["services_type"]?.includes("arrival")}
              onCountClick={() => onClickCounterCard("services_type", ["arrival"])}
            />
            <CounterCards
              bgImage={BooksSpread.src}
              title={"Departure Forms"}
              requestCount={andCounter?.data?.departure_forms ?? 0}
              // @ts-ignore
              selected={filterRef.current["services_type"]?.includes("departure")}
              onCountClick={() => onClickCounterCard("services_type", ["departure"])}
            />
            <CounterCards
              bgImage={Calculator.src}
              title={"Total Forms"}
              requestCount={andCounter?.data?.total_forms ?? 0}
              selected={false}
              onCountClick={() => onClickCounterCard("services_type", undefined)}
            />
          </>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            border: `2px solid #3CA63C`,
            borderRadius: "10px",
            mt: 4,
            p: "0 3px 3px 0",
            height: "100%",
            minHeight: "580px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              background: COLORS.adminAppBgColorV2,
              borderRadius: "10px 10px 0 0",
              height: "80px",
            }}
          >
            <Box sx={{ padding: "20px 30px", display: "block" }}>
              <Button
                ref={filterAnchorDebugref}
                sx={{
                  position: "relative",
                  width: "125px",
                  height: "40px",
                  borderRadius: "5px",
                  background: "rgba(255, 255, 255, 0.15)",
                  color: "#fff",
                  fontSize: "13px",
                  fontWeight: 600,
                  border: "2px solid transparent",
                  borderColor:
                    AppStore.advancedFilter[infiniteTableKey][0]["range"] || AppStore.advancedFilter[infiniteTableKey][0]["value"] !== ""
                      ? "#3CA63C"
                      : undefined,
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.15)",
                  },
                  "& .MuiButton-startIcon": {
                    marginRight: "5px",
                  },
                  "& .MuiButton-endIcon": {
                    marginLeft: "5px",
                  },
                }}
                startIcon={<Image src={FilterIcon} alt="F" width={18} height={18} />}
                endIcon={<Image src={FilterDDIcon} alt="F" width={18} height={18} />}
                onClick={onClickOpenFilters}
                disabled={isEmployee ? false : !isFetchedProperty || !isFetchedEmployees}
              >
                Filters
                {(AppStore.advancedFilter[infiniteTableKey][0]["range"] || AppStore.advancedFilter[infiniteTableKey][0]["value"] !== "") && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -10,
                      right: -10, //
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      background: "#3CA63C",
                      zIndex: 1,
                    }}
                  >
                    {Object.keys(toJS(AppStore.advancedFilter[infiniteTableKey])).length}
                  </Box>
                )}
              </Button>
              <FilterPopover
                // open
                open={filterPopper}
                anchorEl={filterAnchorDebugref.current}
                columns={columns}
                sortBy="headerName"
                onClose={onClickCloseFilters}
                moduleName={infiniteTableKey}
                onChangeAdvFilter={onChangeAdvFilter}
              />
            </Box>
            <FormControlLabel
              control={<Checkbox sx={{ color: "white" }} />}
              label="Hide inactive tickets"
              checked={AppStore.isHideInactiveTickets[infiniteTableKey].isTrue}
              onChange={() => {
                onChangeInactiveTickets(!AppStore.isHideInactiveTickets[infiniteTableKey].isTrue)
              }}
            />
          </Box>
          <InfiniteTable
            infiniteTableKey={infiniteTableKey}
            rows={arrDeptTicketData?.pages?.[arrDeptTicketData?.pages?.length - 1]?.data?.data?.items?.flat() || []}
            columns={columns} // @ts-ignore
            reactQuery={arrDeptRest}
            hiddenColumns={{ owner_stays: false, res_status: false, guest_issue: false, arrival_date: false, departure_date: false, priority: false }}
            getCellClassName={getCellClassName}
            getRowClassName={getRowClassName}
            totalCount={totalNumberOfTickets}
            refs={{
              isNextPage,
              filterRef,
              sortRef,
              tableAPIRef,
            }}
            mapper={{
              // filterIdMap,
              sortIdMap,
            }}
          />

          <NotesModule
            open={openNotesModal}
            onClose={() => setOpenNotesModal(false)}
            moduleName={infiniteTableKey}
            addNotes={
              !isCancelledRef.current && !isNotRequiredRef.current
                ? {
                    notesCount: notesList?.length,
                    onSubmit: onAddNote,
                    mutation: addNoteMutate,
                  }
                : undefined
            }
            previousNotes={{
              data: notesList,
            }}
            bookingNotes={{
              reservationId: modalBookingNotesModal?.reservation?.hostawayReservationId,
              eventType: modalBookingNotesModal?.services_type,
            }}
          />

          <OwnersActionModal
            open={notRequiredModal.open}
            title={notRequiredModal.title}
            desc={notRequiredModal.desc}
            ownerId={notRequiredModal.ownerId}
            onClose={onCancelNotRequiredModal}
            cancel={{
              onCancel: onCancelNotRequiredModal,
              label: "Cancel",
            }}
            submit={{
              onSubmit: onSubmitNotRequiredModal,
              label: notRequiredModal?.submit?.label || "Okie Dokie",
            }}
          />
        </Box>
        <ModalPopup
          title="Download Report For"
          setTriggerFnc={() => setSelectedOptions(null)}
          trigger={Boolean(selectedOptions?.services_type === "departure")}
        >
          <Stack gap="24px">
            <Box display="flex" gap="16px">
              {DOWNLOAD_OPTIONS.map((option) => {
                const selected = selectedOptions?.pdf_type === option.id
                return (
                  <Stack
                    gap="8px"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (!selected) {
                        setSelectedOptions((prev) => {
                          if (prev?.ticket_id) {
                            return {
                              ...prev,
                              pdf_type: option.id,
                            }
                          }
                          return null
                        })
                      }
                    }}
                    justifyContent="center"
                    alignItems="center"
                    key={option.title}
                    border={selected ? `1px solid #58CA04` : undefined}
                    borderRadius="8px"
                    bgcolor="#3E433B"
                    width={162}
                    height={118}
                  >
                    {option.icon}
                    <Typography>{option.title}</Typography>
                  </Stack>
                )
              })}
            </Box>
            <Box paddingTop="20px" display="flex" justifyContent="center" borderTop={`1px solid ${COLORS.customerAppTertiaryButton}`}>
              <Button
                disabled={!selectedOptions?.pdf_type || downloadLoading}
                variant="contained"
                endIcon={downloadLoading ? <CircularProgress color="success" size={16} /> : <Download />}
                onClick={downloadPdfBtnHandler}
              >
                Download
              </Button>
            </Box>
          </Stack>
        </ModalPopup>
      </Box>
    </>
  )
}

const DOWNLOAD_OPTIONS: Array<{ id: "admin" | "guest" | "owner"; title: string; icon: React.ReactElement }> = [
  { id: "owner", title: "Owner", icon: <OwnerIcon /> },
  { id: "guest", title: "Guest", icon: <GroupUserIcon /> },
  { id: "admin", title: "Admin", icon: <AdminUserIcon /> },
]

export default ProtectedAuth(observer(ArrivalDepartureHome))
